export default __webpack_public_path__ + "static/media/achievr-bg.0e846c10.png";